import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ProductListComponent } from './components/products/product-list/product-list.component';
import { EditProfileComponent } from './components/profile/edit-profile/edit-profile.component';
import { SummaryComponent } from './components/profile/summary/summary.component';
import { RegisterComponent } from './components/register-users/register/register.component';
import { SocialNetworkRegisterComponent } from './components/register-users/social-network-register/social-network-register.component';
import { SocialNetworkRegisterResolver } from './_resolvers/social-network-register.resolver';
import { UserEditResolver } from './_resolvers/user-edit.resolver';
import { ProductListResolver } from './_resolvers/product-list.resolver';
import { ProductViewComponent } from './components/products/product-view/product-view.component';
import { ProductViewResolver } from './_resolvers/product-view.resolver';
import { PreventEditUserUnsavedChangesGuard } from './_guards/prevent-edit-user-unsaved-changes.guard';
import { ShoppingCartComponent } from './components/orders/shopping-cart/shopping-cart.component';
import { ShoppingCartResolver } from './_resolvers/shopping-cart.resolver';
import { EpaycoResponseComponent } from './components/orders/epayco-response/epayco-response.component';
import { ReferredComponent } from './components/profile/referred/referred.component';
import { OrderHistoryComponent } from './components/profile/order-history/order-history.component';
import { PurchaseDetailComponent } from './components/profile/purchase-detail/purchase-detail.component';
import { HelpFormComponent } from './components/profile/help-form/help-form.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: '',
    component: HomeComponent,
    outlet: 'sidebar'
  },
  {
    path: 'profile',
    component: SummaryComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    component: SummaryComponent,
    outlet: 'sidebar'
  },
  {
    path: 'referred',
    component: ReferredComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'referred',
    component: ReferredComponent,
    outlet: 'sidebar'
  },
  {
    path: 'compras',
    component: OrderHistoryComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'compras',
    component: OrderHistoryComponent,
    outlet: 'sidebar'
  },
  {
    path: 'purchasesDetail',
    component: PurchaseDetailComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'purchasesDetail',
    component: PurchaseDetailComponent,
    outlet: 'sidebar'
  },
  // {
  //   path: 'purchasesDetail/:id',
  //   component: PurchaseDetailComponent,
  //   // canActivate: [AuthGuard],
  // },
  // {
  //   path: 'purchasesDetail/:id',
  //   component: PurchaseDetailComponent,
  //   outlet: 'sidebar'
  // },
  {
    path: 'helpWithProduct/:id',
    component: HelpFormComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'helpWithProduct/:id',
    component: HelpFormComponent,
    outlet: 'sidebar'
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'register',
    component: RegisterComponent,
    outlet: 'sidebar'
  },
  {
    path: 'social-network-register',
    resolve: { user: SocialNetworkRegisterResolver },
    component: SocialNetworkRegisterComponent
  },
  {
    path: 'social-network-register',
    component: SocialNetworkRegisterComponent,
    outlet: 'sidebar',
    resolve: { user: SocialNetworkRegisterResolver }
  },
  {
    path: 'edit-profile',
    component: EditProfileComponent,
    resolve: { privateProfile: UserEditResolver },
    // canDeactivate: [PreventEditUserUnsavedChangesGuard]
  },
  {
    path: 'edit-profile',
    component: EditProfileComponent,
    resolve: { privateProfile: UserEditResolver },
    outlet: 'sidebar'
    // canDeactivate: [PreventEditUserUnsavedChangesGuard]
  },
  {
    path: 'shopping-cart',
    component: ShoppingCartComponent,
    resolve: { shoppingCart: ShoppingCartResolver}
  },
  {
    path: 'shopping-cart',
    component: ShoppingCartComponent,
    outlet: 'sidebar',
    resolve: { shoppingCart: ShoppingCartResolver}
  },
  {
    path: 'epayco-response',
    component: EpaycoResponseComponent
  },
  {
    path: 'products/:category',
    component: ProductListComponent,
    resolve: { products: ProductListResolver }
  },
  {
    path: 'products/:category',
    component: ProductListComponent,
    outlet: 'sidebar',
    resolve: { products: ProductListResolver }
  },
  {
    path: 'product/:id',
    component: ProductViewComponent,
    resolve: { product: ProductViewResolver }
  },
  {
    path: 'product/:id',
    component: ProductViewComponent,
    outlet: 'sidebar',
    resolve: { product: ProductViewResolver }
  },
  //Enlaces para habeas data y para eliminar cuenta//
  // {
  //   path: 'habeas-data',
  //   component: ,
  //   outlet: 'sidebar',
  //   resolve: { product: ProductViewResolver }
  // },
  // {
  //   path: 'profile/delete-acount',
  //   component: ,
  //   outlet: 'sidebar',
  //   resolve: { product: ProductViewResolver }
  // },

  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
